import perDiem from "../../config/fields/perDiem";

const $inject = ['$q', 'dataService', 'perDiemService', '$timeout', '$rootScope', '$scope', '$http', '$window', '$location'];

const lbaPerDiemGridItemCtrl = function ($q, dataService, perDiemService, $timeout, $rootScope, $scope, $http, $window, $location) {
  let vm = this;
  vm.hasError = false;
  vm.addNewMode = false;
  vm.copyNode = false;
  vm.deleteConfirm = false;
  vm.cancelConfirm = false;

  vm.returnToGrid = returnToGrid;
  vm.savePerDiem = savePerDiem;
  vm.deletePerDiem = deletePerDiem;
  vm.openEffectiveDate = openEffectiveDate;
  vm.openExpirationDate = openExpirationDate;

  vm.dateFormat = 'MM/dd/yyyy';
  var today = new Date();
  vm.placeholder = today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear();

  vm.status = {
    openedEffectiveDate: false,
    openedExpirationDate: false,
    perDiemGridStatus: perDiemService.perDiemGridStatus
  };

  vm.dateOptions = {
    formatYear: 'yy',
    startingDay: 0,
    showWeeks: false
  };

  if (!vm.status.perDiemGridStatus)
    vm.status.perDiemGridStatus = window.localStorage['perDiemGridStatus'];

  if (vm.status.perDiemGridStatus == "edit" || vm.status.perDiemGridStatus == "copy") {
    if (perDiemService.perDiemGridItem) {
      vm.row = perDiemService.perDiemGridItem;
    }
    else {
      var lsPerDiemGridItem = window.localStorage['perDiemGridItem'];
      if (lsPerDiemGridItem) {
        vm.row = angular.fromJson(lsPerDiemGridItem);
      }
      else {
        returnToGrid();
      }
    }

    if (vm.status.perDiemGridStatus == "copy")
      vm.copyNode = true;
  }
  else if (vm.status.perDiemGridStatus == "add") {
    vm.addNewMode = true;
  }

  if (!vm.row)
    vm.row = { Source: "ContinentalUS" };

  function openEffectiveDate() {
    vm.status.openedEffectiveDate = true;
  }

  function openExpirationDate() {
    vm.status.openedExpirationDate = true;
  }

  function returnToGrid() {
    $location.path("/per-diem");
  }

  function savePerDiem() {
    vm.saving = true;
    vm.messages = "";

    $rootScope.$broadcast('lbaToast:showToast', { message: `Saving per diem...`, messageType: 'waiting' });

    if (!vm.row.LodgingPerDiem)
      vm.row.LodgingPerDiem = 0;
    if (!vm.row.SeasonStartMonth)
      vm.row.SeasonStartMonth = 0;
    if (!vm.row.SeasonStartDay)
      vm.row.SeasonStartDay = 0;
    if (!vm.row.SeasonEndMonth)
      vm.row.SeasonEndMonth = 0;
    if (!vm.row.SeasonEndDay)
      vm.row.SeasonEndDay = 0;

    var perDiem = vm.row;
    if (vm.status.perDiemGridStatus == "copy")
      perDiem.id = null;

    perDiemService.save(perDiem, (response, status, headers) => {
      if (response.Success) {
        vm.hasError = false;
        vm.addNewMode = false;
        vm.copyNode = false;

        $rootScope.$broadcast('lbaToast:showToast', { message: `Per diem has been saved.`, messageType: 'success' });
        vm.row = response.PerDiems[0];
        vm.status.perDiemGridStatus = "edit";
        window.localStorage['perDiemGridItem'] = JSON.stringify(vm.row);
        window.localStorage['perDiemGridStatus'] = "edit";
      }
      else {
        vm.hasError = true;
        $rootScope.$broadcast('lbaToast:showToast', { message: 'There are errors.', messageType: 'error' });

        if (response.Message)
          vm.messages = response.Message;
        else
          vm.messages = response.Messages.join("\n");

        window.scrollTo(0, 0);
      }

      vm.saving = false;
    }, (response, status) => {
      vm.hasError = true;
      $rootScope.$broadcast('lbaToast:showToast', { message: 'There are errors.', messageType: 'error' });

      if (response.Message)
        vm.messages = response.Message;
      else
        vm.messages = response.Messages.join("\n");

      window.scrollTo(0, 0);
      vm.saving = false;
    });
  }

  function deletePerDiem() {
    const url = `${endPointUrl}/api/PerDiem/Delete`;

    var perDiem = vm.row;
    perDiemService.deletePerDiem(perDiem, (response, status, headers) => {
      vm.hasError = false;
      returnToGrid();
      $rootScope.$broadcast('lbaToast:showToast', { message: `Per diem has been deleted.`, messageType: 'success' });
    }, (response, status) => {
      vm.hasError = true;
      $rootScope.$broadcast('lbaToast:showToast', { message: 'There are errors.', messageType: 'error' });

      if (response.Message) {
        vm.messages = response.Message;
      }
      else {
        vm.messages = response.Messages.join("\n");
      }

      window.scrollTo(0, 0);
      vm.saving = false;
    })
  }
};

lbaPerDiemGridItemCtrl.$inject = $inject;

export default lbaPerDiemGridItemCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaPerdiemGridItem/lbaPerDiemGridItemCtrl.js